import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import '@mantine/core/styles.css';
import './app/app.module.css';
import './config/setupTranslations';
import './config/setupPolyfills';
import { mantineCustomTheme } from './app/theme';
import './assets/Carnero/Carnero.css';

import App from './app/app';
import { MantineProvider } from '@mantine/core';
import {
  KeycloakProvider,
  keycloakStore,
  UserDataProvider,
  userDataStore,
} from './app/shared_stores';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <MantineProvider theme={mantineCustomTheme}>
      <KeycloakProvider store={keycloakStore}>
        <UserDataProvider store={userDataStore}>
          <App />
        </UserDataProvider>
      </KeycloakProvider>
    </MantineProvider>
  </StrictMode>,
);
